module.exports = __webpack_public_path__ + "img/logo-white.b3b9b8a6.svg";